class KadreFacetQuickFilters extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.onClick);
    this.updateOverflow = this.updateOverflow.bind(this);
  }

  connectedCallback() {
    this.scroller = this.querySelector('.kadre-facet-quick-filters__scroller');
    if (!this.scroller) return;

    this.resizeObserver = new ResizeObserver(this.updateOverflow);
    this.resizeObserver.observe(this.scroller);
    requestAnimationFrame(this.updateOverflow);
  }

  disconnectedCallback() {
    if (this.resizeObserver) this.resizeObserver.disconnect();
  }

  updateOverflow() {
    if (!this.scroller) return;
    this.classList.toggle('is-overflowing', this.scroller.scrollWidth > this.scroller.clientWidth + 1);
  }

  onClick(event) {
    const button = event.target.closest('[data-kadre-facet-index]');
    if (!button || !this.contains(button)) return;

    const drawer = document.getElementById(button.getAttribute('aria-controls'));
    if (!drawer) return;

    const facetIndex = button.dataset.kadreFacetIndex;
    const facet = Array.from(drawer.querySelectorAll('[data-filter][data-index]')).find(
      (element) => element.dataset.index === facetIndex
    );
    if (!facet) return;

    facet.open = true;

    const focusFacet = () => {
      const summary = facet.querySelector('summary');
      if (summary) summary.focus({ preventScroll: true });
      facet.scrollIntoView({
        behavior: FoxTheme.config.enableAnimations ? 'smooth' : 'auto',
        block: 'start',
      });
    };

    drawer.addEventListener('drawer:handleAfterShow', focusFacet, { once: true });
    if (!drawer.open) drawer.show(button);
  }
}

customElements.define('kadre-facet-quick-filters', KadreFacetQuickFilters);
